import React from 'react';
import { View } from 'react-native';
import { Text } from '~/components';
import { MarisaAppUtils } from '~/utils/MarisaAppUtils';
import { ASSURANT_WEBSITE } from '~/utils/url';
import { GENERAL_CONDITIONS_LINK } from '../../constants';

interface ItemProps {
  label: string;
  value?: string;
}

const Item = ({ label, value }: ItemProps) => (
  <Text className={'font-medium text-gray-400 text-[12px] text-center'}>
    {label}{' '}
    {!!value && <Text className="text-primary-600 font-normal">{value}</Text>}
  </Text>
);

interface Props {
  className?: string;
}

const GeneralInfoFooter: React.FC<Props> = ({ className }) => {
  return (
    <View className={className}>
      {!MarisaAppUtils.isTotem() && (
        <Text className="text-xs text-gray-400 text-center">
          Este seguro é administrado pela{' '}
          <Text
            className="text-primary-600 text-xs font-medium"
            onPress={() => MarisaAppUtils.openUrl(ASSURANT_WEBSITE)}
          >
            Assurant
          </Text>
          .
        </Text>
      )}
      <Text className="text-xs text-gray-400 text-center mb-4">
        Condições gerais do Proteção Bolsa:{' '}
        <Text
          className="text-primary-600 text-xs font-medium"
          onPress={() => MarisaAppUtils.openUrl(GENERAL_CONDITIONS_LINK)}
        >
          Consulte
        </Text>
      </Text>
      <Item
        label="Atendimento ao cliente 24 horas"
        value="7 dias por semana."
      />

      <Item label="Serviço de atendimento SAC:" value="0800-777-9406" />

      <Item label="Deficiente auditivo/fala:" value="0800-771-7266" />

      <Item label="Horário de atendimento de segunda à sábado das 8h às 20h" />

      <View className="mb-4" />

      <Item
        label="Central de Atendimento (Abertura de Sinistro):"
        value="3003-0956"
      />

      <Text className="font-normal text-gray-400 text-[12px] text-center mb-4">
        (Capitais e Regiões Metropolitanas){' '}
        <Text className="text-primary-600 font-normal">e 0800 606 6302</Text>{' '}
        (Demais Regiões)
      </Text>

      <Item label="Ouvidoria" />
      <Text className="font-normal text-gray-400 text-[12px] text-center">
        Caso já tenha registrado sua reclamação no SAC e não esteja satisfeito
        ligue{' '}
        <Text className="text-primary-600 font-normal">0800 771 7266</Text>{' '}
        (Atendimento das 09h às 18h de segunda à sexta) ou entre em contato por
        e-mail{' '}
        <Text className="text-primary-600 font-normal underline">
          ouvidoria@assurant.com
        </Text>
      </Text>
    </View>
  );
};

export default GeneralInfoFooter;
